/* src/app/components/game-layer/character-create-component/character-create-component.css */
.character-create-card {
  max-width: 880px;
  margin: 0 auto;
}
.character-create-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 18px 0 22px;
  color: var(--ink-soft);
}
.character-create-meta span {
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(240, 215, 122, 0.14);
  background: rgba(255, 255, 255, 0.04);
}
.character-create-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.form-group span {
  color: #f3e7c0;
  font-weight: 600;
}
.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}
.validation-text {
  margin-top: 16px;
  color: #ffb8a2;
}
/*# sourceMappingURL=character-create-component.css.map */
